<template>
  <div @paste="onPaste">
    <el-card shadow="always">
      <el-page-header @back="back" title :content="$t('importar-tabela-preco')"></el-page-header>
    </el-card>
    <el-card>
      <el-form :model="ruleForm" ref="ruleForm" label-position="top" :status-icon="true" :rules="rules"
        :inline-message="true">
        <el-row :gutter="5">
          <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
            <el-form-item :label="$t('pacote')" prop="packagetable">
              <PackageTableList v-model="ruleForm.packagetable" v-bind:current="ruleForm.packagetable" />
            </el-form-item>
          </el-col>
          <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
            <el-form-item :label="$t('grupo-servico')" prop="servicesgroup">
              <ServicesGroupList v-model="ruleForm.servicesgroup" v-bind:current="ruleForm.servicesgroup" />
            </el-form-item>
          </el-col>
        </el-row>
        <br />
        <el-alert :description="$t('copie-planilha-excel')" type="info" v-if="tableData.length == 0" :closable="false">
        </el-alert>
        <el-table :data="tableData" stripe style="width: 100%" v-if="tableData.length != 0"
          :default-sort="{ prop: 'name', order: 'ascending' }">
          <el-table-column sortable :label="$t('peso')">
            <template slot-scope="scope">{{ scope.row.description }}</template>
          </el-table-column>

          <el-table-column width="80px" prop="l1" label="L1">
            <template slot-scope="scope">{{
              scope.row.l1 | currency
            }}</template>
          </el-table-column>
          <el-table-column width="80px" prop="l2" label="L2">
            <template slot-scope="scope">{{
              scope.row.l2 | currency
            }}</template>
          </el-table-column>
          <el-table-column width="80px" prop="l3" label="L3">
            <template slot-scope="scope">{{
              scope.row.l3 | currency
            }}</template>
          </el-table-column>
          <el-table-column width="80px" prop="l4" label="L4">
            <template slot-scope="scope">{{
              scope.row.l4 | currency
            }}</template>
          </el-table-column>
          <el-table-column width="80px" prop="e1" label="E1">
            <template slot-scope="scope">{{
              scope.row.e1 | currency
            }}</template>
          </el-table-column>
          <el-table-column width="80px" prop="e2" label="E2">
            <template slot-scope="scope">{{
              scope.row.e2 | currency
            }}</template>
          </el-table-column>
          <el-table-column width="80px" prop="e3" label="E3">
            <template slot-scope="scope">{{
              scope.row.e3 | currency
            }}</template>
          </el-table-column>
          <el-table-column width="80px" prop="e4" label="E4">
            <template slot-scope="scope">{{
              scope.row.e4 | currency
            }}</template>
          </el-table-column>
          <el-table-column width="80px" prop="n1" label="N1">
            <template slot-scope="scope">{{
              scope.row.n1 | currency
            }}</template>
          </el-table-column>
          <el-table-column width="80px" prop="n2" label="N2">
            <template slot-scope="scope">{{
              scope.row.n2 | currency
            }}</template>
          </el-table-column>
          <el-table-column width="80px" prop="n3" label="N3">
            <template slot-scope="scope">{{
              scope.row.n3 | currency
            }}</template>
          </el-table-column>
          <el-table-column width="80px" prop="n4" label="N4">
            <template slot-scope="scope">{{
              scope.row.n4 | currency
            }}</template>
          </el-table-column>
          <el-table-column width="80px" prop="p1" label="P1">
            <template slot-scope="scope">{{
              scope.row.p1 | currency
            }}</template>
          </el-table-column>
          <el-table-column width="80px" prop="p2" label="P2">
            <template slot-scope="scope">{{
              scope.row.p2 | currency
            }}</template>
          </el-table-column>
          <el-table-column width="80px" prop="p3" label="P3">
            <template slot-scope="scope">{{
              scope.row.p3 | currency
            }}</template>
          </el-table-column>
          <el-table-column width="80px" prop="p4" label="P4">
            <template slot-scope="scope">{{
              scope.row.p4 | currency
            }}</template>
          </el-table-column>
          <el-table-column width="80px" prop="i1" label="I1">
            <template slot-scope="scope">{{
              scope.row.i1 | currency
            }}</template>
          </el-table-column>
          <el-table-column width="80px" prop="i2" label="I2">
            <template slot-scope="scope">{{
              scope.row.i2 | currency
            }}</template>
          </el-table-column>
          <el-table-column width="80px" prop="i3" label="I3">
            <template slot-scope="scope">{{
              scope.row.i3 | currency
            }}</template>
          </el-table-column>
          <el-table-column width="80px" prop="i4" label="I4">
            <template slot-scope="scope">{{
              scope.row.i4 | currency
            }}</template>
          </el-table-column>
        </el-table>
        <br />
        <el-form-item style="text-align: center">
          <el-button type="warning" autofocus @click="submitForm('ruleForm')">{{
            $t("importar")
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template> 
<script>
import { PriceTableService } from "@/services/customers/price.table.services";
import { i18n } from "@/plugin/i18n";
import ZipMixins from "../../../mixins/zipcode";
import ServicesGroupList from "@/xpost/views/register/services.group/ServicesGroupList";
import PackageTableList from "@/xpost/views/financial/package/PackageTableList";

export default {
  name: "CustomerAdd",
  mixins: [ZipMixins],
  components: {
    ServicesGroupList,
    PackageTableList,
  },
  data() {
    return {
      tableData: [],
      ruleForm: {
        packagetable: "",
        servicesgroup: "",
      },
      rules: {
        packagetable: [
          {
            required: true,
            message: i18n.tc("tabela-pacote-obrigatorio"),
            trigger: "blur",
          },
        ],
        servicesgroup: [
          {
            required: true,
            message: i18n.tc("servico-obrigatorio"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    back() {
      var vm = this;
      vm.$router.push("/cadastro/tabelapreco").catch(() => { });
    },
    submitForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          if (vm.tableData.length == 0) {
            return vm.$message({
              type: "error",
              message: i18n.tc("voce-deve-informar-itens-importacao"),
            });
          }
          PriceTableService.findByPackageService(
            vm.ruleForm.packagetable,
            vm.ruleForm.servicesgroup
          )
            .then((response) => {
              if (response.length === 0) return vm.save();

              vm.$confirm(
                i18n.tc("ja-existe-servico-tabelapacote-servico"),
                "Warning",
                {
                  confirmButtonText: i18n.tc("sim"),
                  cancelButtonText: i18n.tc("nao"),
                  type: "warning",
                }
              )
                .then(() => {
                  vm.save();
                })
            })
            .catch(() => {
              vm.save();
            })
        } else {
          return false;
        }
      });
    },
    save() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      PriceTableService.import(vm.ruleForm, vm.tableData)
        .then((response) => {
          this.$message({
            type: "success",
            message: i18n.tc("tabela-preco-importada-sucesso"),
          });
          vm.tableData = [];
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    onPaste(evt, el) {
      const vm = this;
      const paste = evt.clipboardData.getData("text");
      const rows = paste.split("\n");
      vm.tableData = [];
      for (const line of rows) {
        const item = line.split("\t");
        if (item.length !== 21 && item.length !== 17) {
          continue;
        }
        let t = item[0].toLowerCase().split("a");
        let km = false;
        if (t.length !== 2 && item[0].toLowerCase().indexOf("kg") !== -1) {
          t = ["0", "0"];
          km = true;
        } else if (t.length !== 2) {
          continue;
        }
        const start = +t[0].replace(".", "").replace(",", ".");
        const end = +t[1].replace(".", "").replace(",", ".");
        if (isNaN(start) || isNaN(end)) {
          continue;
        }
        let n = 1;
        const data = {
          description: km ? `Kg Adicional` : `${start} até ${end}`,
          weightstart: start,
          weightend: end,
          l1: item.length == 17 ? 0 : +item[n++].replace(",", "."),
          l2: item.length == 17 ? 0 : +item[n++].replace(",", "."),
          l3: item.length == 17 ? 0 : +item[n++].replace(",", "."),
          l4: item.length == 17 ? 0 : +item[n++].replace(",", "."),
          e1: +item[n++].replace(",", "."),
          e2: +item[n++].replace(",", "."),
          e3: +item[n++].replace(",", "."),
          e4: +item[n++].replace(",", "."),
          n1: +item[n++].replace(",", "."),
          n2: +item[n++].replace(",", "."),
          n3: +item[n++].replace(",", "."),
          n4: +item[n++].replace(",", "."),
          p1: +item[n++].replace(",", "."),
          p2: +item[n++].replace(",", "."),
          p3: +item[n++].replace(",", "."),
          p4: +item[n++].replace(",", "."),
          i1: +item[n++].replace(",", "."),
          i2: +item[n++].replace(",", "."),
          i3: +item[n++].replace(",", "."),
          i4: +item[n++].replace(",", "."),
          km: km,
        };
        vm.tableData.push(data);
      }
    },
  },
  mounted() { },
};
</script>
<style scoped>
.el-page-header__left {
  display: flex !important;
}

form {
  margin-top: 20px;
}

@media screen and (min-width: 458px) {
  .col-form-label {
    text-align: right;
  }
}
</style>
